/**
 * Recovery after a new deployment. Page code is split into hashed files; a tab opened before
 * a deploy still asks for the old file names, which no longer exist. Reloading once picks up
 * the new version. A short guard prevents reload loops when the server is really failing.
 */
const KEY = 'pirochi:version-reload-at';

export function isChunkLoadError(e: unknown): boolean {
  const m = e instanceof Error ? e.message : String(e);
  return /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|Unable to preload CSS/i.test(
    m,
  );
}

/** Reloads the page unless that was already tried in the last 10 s. Returns whether it reloads. */
export function reloadForNewVersion(): boolean {
  try {
    if (Date.now() - Number(sessionStorage.getItem(KEY) || 0) < 10_000) return false;
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    // storage unavailable (private mode) — still try one reload
  }
  window.location.reload();
  return true;
}
